import Api from '@/services/Api'

const URL = 'cat/producto-barra/';

export default {
    
    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('pk' in params) {
            return Api().put(url + params.pk + '/', params)
        }
        return Api().post(url, params)
    },
    delete(id) {
        let url = URL;
        return Api().delete(url + id + '/', {})
    }
}